<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <v-toolbar :flat="true" class="app-navbar" dense>
    <v-toolbar-title>
      <a href="/" title="Interactive Search Main">
        <img
          src="../assets/ECLogoWithProviderTrust.png"
          alt="ExclusionCheck"
          class="app-nav-logo"
        />
      </a>
    </v-toolbar-title>

    <v-spacer />

    <span v-if="isLoggedIn" class="welcome-banner">
      Welcome, {{ fullName }} from {{ clientName }}
    </span>

    <v-toolbar-items class="menus">
      <v-menu
        v-for="menu in menus"
        :key="menu.name"
        v-if="
          isLoggedIn &&
            menu.menuItems.some(menuItem => hasAccess(menuItem.roles))
        "
        bottom
        right
        open-on-hover
        close-delay="0"
        offset-y
      >
        <v-btn flat slot="activator" color="primary">
          <v-icon left>{{ menu.icon }}</v-icon
          >{{ menu.title }}
        </v-btn>

        <v-list class="menuitems">
          <v-list-tile
            v-for="menuItem in menu.menuItems"
            :key="menuItem.title"
            v-if="hasAccess(menuItem.roles)"
            v-show="
              menuItem.hide && $store.getters[menuItem.hide] ? false : true
            "
            v-bind="
              menuItem.type === 'vue'
                ? { to: menuItem.link }
                : { href: menuItem.link }
            "
            class="menuitem"
          >
            <v-list-tile-title>
              <v-icon left>{{ menuItem.icon }}</v-icon
              >{{ menuItem.title }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isLoggedIn"
        color="primary"
        href="https://www.providertrust.com/get-started/"
        target="_blank"
        rel="noopener noreferrer"
        flat
      >
        <v-icon left>fa fa-plus-square</v-icon>Register
      </v-btn>

      <v-btn v-if="!isLoggedIn" color="primary" to="/login" flat>
        <v-icon left>fa fa-sign-in</v-icon>Login
      </v-btn>

      <v-btn color="primary" @click="help" flat>
        <v-icon left>fa fa-question-circle</v-icon>Help
      </v-btn>

      <v-btn color="primary" @click="print" flat>
        <v-icon left>fa fa-print</v-icon>Print
      </v-btn>

      <v-btn
        v-if="isLoggedIn"
        color="primary"
        @click="logout"
        href="/csarf/v2/#/login"
        flat
      >
        <v-icon left>fa fa-sign-out</v-icon>Logout
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex"
import { menus } from "@/common/constants"
import { launchHelp } from "@/service/zendesk"

export default {
  data() {
    return {
      menus
    }
  },
  computed: {
    ...mapGetters([
      "hasAccess",
      "isLoggedIn",
      "fullName",
      "clientName",
      "hasPrivateHelpPage",
      "privateHelpPage"
    ])
  },
  methods: {
    help() {
      if (this.privateHelpPage) {
        window.location.replace(window.location.origin + this.privateHelpPage)
      } else {
        launchHelp()
      }
    },
    print() {
      window.print()
    },
    logout() {}
  }
}
</script>

<style lang="scss">
.app-navbar {
  font-size: 0.875rem;
  .menus {
    .v-btn {
      text-decoration: none;
      text-transform: none;
      transition: none;
      border-radius: 0;
      .v-icon--left {
        margin-right: 0.25rem;
        transition: none;
      }
      &.v-btn--active,
      &:hover,
      &:focus {
        color: $color-white !important; // primary color is used
        background-color: $color-ec-blue !important; // flat btn has transparent background
      }
    }
  }
  .welcome-banner {
    margin-right: 1rem;
    color: $color-ec-blue;
  }
}
.menuitems {
  padding: 0;
  .menuitem {
    > a.v-list__tile {
      text-decoration: none;
      color: $color-ec-blue;
      font-size: 0.875rem;
      background-color: $color-ec-lightest-gray;
      .v-list__tile__title {
        transition: none;
      }
      &.v-list__tile--active,
      &:hover {
        color: $color-white !important; // primary color is added by vuetify
        background-color: $color-ec-blue;
        .v-icon--left {
          color: $color-white;
        }
      }
      .v-icon--left {
        margin-right: 0.25rem;
        min-width: 1rem;
        color: $color-ec-blue;
        text-align: center;
      }
    }
  }
}
.app-nav-logo {
  width: 230px;
  padding: 0.5rem 0 0 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue